import hyperform from "hyperform"
import maskInput from "vanilla-text-mask"
import SmoothScroll from "smooth-scroll"
import { q } from "../../helper/q"
import { scroll } from "../../globals/smoth"

// const scroll = new SmoothScroll('.up a[href*="#"]')

export const faqFormInit = () => {
  const referencePopupBlock = document.querySelector("#referencePopup")
  const buttonReferencePopup = document.querySelector(".buttonQuestion")
  const referencePopupButtonClose = document.querySelector(".referenceButtonClose")
  const referencePopupForm = document.querySelector(".referenceForm")
  // const referencePopupMobileButton = document.querySelector(".referenceMobileButton button")

  if (referencePopupForm) {
    buttonReferencePopup.addEventListener("click", () => {
      if (!referencePopupBlock.classList.contains("referencePopupVisible")) {
        referencePopupBlock.classList.add("referencePopupVisible")
        buttonReferencePopup.classList.add("buttonReferencePopupActive")
        if (q("span", buttonReferencePopup)) {
          q("span", buttonReferencePopup).innerHTML = q("span", buttonReferencePopup).dataset.closeMessage
        }

        scroll.animateScroll(document.querySelector("#referencePopup"), null, {
          offset: 250,
          durationMax: 500
        })
      } else if (referencePopupBlock.classList.contains("referencePopupVisible")) {
        referencePopupBlock.classList.remove("referencePopupVisible")
        buttonReferencePopup.classList.remove("buttonReferencePopupActive")
        if (q("span", buttonReferencePopup)) {
          q("span", buttonReferencePopup).innerHTML = q("span", buttonReferencePopup).dataset.openMessage
        }
      }
    })

    referencePopupButtonClose.addEventListener("click", () => {
      if (referencePopupBlock.classList.contains("referencePopupVisible")) {
        referencePopupBlock.classList.remove("referencePopupVisible")
        buttonReferencePopup.classList.remove("buttonReferencePopupActive")
        if (q("span", buttonReferencePopup)) {
          q("span", buttonReferencePopup).innerHTML = q("span", buttonReferencePopup).dataset.openMessage
        }
        buttonReferencePopup.dataset.openMessage
        referencePopupButtonClose.classList.remove("referencePopupButtonCloseVisible")
        scroll.animateScroll(document.querySelector(".pageContainer"), null, {
          offset: 200,
          durationMax: 500
        })
      }
    })

    // referencePopupMobileButton.addEventListener("click", () => {
    //   scroll.animateScroll(document.querySelector("#referencePopup"), event.target, {
    //     offset: 130
    //   })
    //   referencePopupBlock.classList.add("referencePopupVisible")
    //   referencePopupButtonClose.classList.add("referencePopupButtonCloseVisible")
    // })

    hyperform.setRenderer("attachWarning", function(warning, element) {
      element.parentNode.classList.add("floatInputError")
      element.parentNode.querySelector(".floatInputLabel").innerHTML = warning.innerHTML
    })

    hyperform(referencePopupForm)

    if (referencePopupForm.querySelector("input[type='tel']")) {
      hyperform.addValidator(referencePopupForm.querySelector("input[type='tel']"), element => {
        const re = /^(\+7|7|8)?[\s/\\-]?\(?[0-9]{3}\)?[\s/\\-]?[0-9]{3}[\s/\\-]?[0-9]{2}[\s/\\-]?[0-9]{2}$/gm
        const valid = re.test(element.value)
        element.setCustomValidity(
          valid ? "" : element.value ? element.dataset.typeMismatch : element.dataset.valueMissing
        )
        return valid
      })
      maskInput({
        inputElement: referencePopupForm.querySelector("input[type='tel']"),
        mask: ["+", /[1-9]/, " ", "(", /[1-9]/, /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/],
        showMask: false,
        keepCharPositions: false
      })
    }

    referencePopupForm.addEventListener("submit", event => {
      event.preventDefault()
      event.stopPropagation()
      if (hyperform.checkValidity(referencePopupForm)) {
        const button = referencePopupForm.querySelector('button[type="submit"]')
        button.style.width = button.offsetWidth + "px"
        button.innerHTML = loader
        sendForm(referencePopupForm).then(resss => {
          if (resss.message.TYPE === "ERROR") {
            document.querySelector(".referenceFeedback").innerHTML = resss.message.MESSAGE
            const button = document.querySelector(".referenceCloseSuccessButton")
            if (button)
              button.addEventListener("click", () => {
                if (referencePopupBlock.classList.contains("referencePopupVisible")) {
                  referencePopupBlock.classList.remove("referencePopupVisible")
                  buttonReferencePopup.classList.remove("buttonReferencePopupActive")
                  buttonReferencePopup.innerHTML = "Задать вопрос"
                  referencePopupButtonClose.classList.remove("referencePopupButtonCloseVisible")
                  scroll.animateScroll(document.querySelector(".pageContainer"), null, {
                    offset: 200
                  })
                }
              })
          }
          if (resss.message.TYPE === "OK") {
            document.querySelector(".referenceFeedback").innerHTML = resss.message.MESSAGE
            const button = document.querySelector(".referenceCloseSuccessButton")
            scroll.animateScroll(document.querySelector(".referenceFeedback"), null, {
              offset: 200
            })
            if (button)
              button.addEventListener("click", e => {
                if (referencePopupBlock.classList.contains("referencePopupVisible")) {
                  referencePopupBlock.classList.remove("referencePopupVisible")
                  buttonReferencePopup.classList.remove("buttonReferencePopupActive")
                  buttonReferencePopup.innerHTML = "Задать вопрос"
                  referencePopupButtonClose.classList.remove("referencePopupButtonCloseVisible")
                  scroll.animateScroll(document.querySelector(".pageContainer"), e.target, {
                    offset: 200
                  })
                }
              })
          }
        })
      }
    })
  }
}

const sendForm = form => {
  const formData = new FormData(form)
  const options = {
    method: "POST",
    credentials: "include",
    body: formData
  }
  return fetch("/zadat-vopros/", options).then(res => res.json())
}

const loader = /* html */ `<div class="spinner">
<div class="bounce1"></div>
<div class="bounce2"></div>
<div class="bounce3"></div>
</div>`
